import {
  fundingProgramFilterExists,
  getFundingProgramProperties,
  updateFundingProgramSearchFilter,
} from "@outschool/funding-programs-shared";
import { SearchFilters as SearchFiltersType } from "@outschool/gql-backend-generated";
import { useTranslation } from "@outschool/localization";
import { ToggleButton } from "@outschool/ui-legacy-component-library";
import React from "react";

import {
  FundingProgramFilterSource,
  useClassWalletSessionFundingProgramAbbr,
  useSearchFiltersFundingProgramAbbr,
} from "./utils";

export function useGetProgramForFundingProgramButton(searchFilters?: {
  fundingPrograms?: string[] | string | null;
}) {
  const classWalletFundingProgramAbbr =
    useClassWalletSessionFundingProgramAbbr();
  const searchFiltersFundingProgramAbbr =
    useSearchFiltersFundingProgramAbbr(searchFilters);

  if (!!classWalletFundingProgramAbbr) {
    return {
      properties: getFundingProgramProperties(classWalletFundingProgramAbbr),
      source: FundingProgramFilterSource.ClassWallet,
    };
  } else if (!!searchFiltersFundingProgramAbbr) {
    return {
      properties: getFundingProgramProperties(searchFiltersFundingProgramAbbr),
      source: FundingProgramFilterSource.SearchFilters,
    };
  }
  return {
    properties: null,
    source: null,
  };
}

export function useShowFundingProgramButton(searchFilters?: SearchFiltersType) {
  return !!useGetProgramForFundingProgramButton(searchFilters).properties;
}

export default function FundingProgramButton({
  updateSearchFilters,
  searchFilters,
}: {
  updateSearchFilters: (payload: SearchFiltersType) => void;
  searchFilters?: SearchFiltersType;
  searchUid?: string;
}) {
  const { t } = useTranslation(
    "ui-components-website\\src\\Search\\FundingProgram\\FundingProgramButton"
  );

  const { properties: fundingProgramProperties } =
    useGetProgramForFundingProgramButton(searchFilters);

  if (!fundingProgramProperties) {
    return null;
  }

  return (
    <ToggleButton
      size="small"
      enabled={fundingProgramFilterExists(searchFilters)}
      onClick={() => {
        updateSearchFilters({
          fundingPrograms: updateFundingProgramSearchFilter(
            searchFilters,
            fundingProgramProperties.abbreviation
          ),
        });
      }}
    >
      {t("{{fundingProgramName}} Eligible", {
        fundingProgramName: fundingProgramProperties.programName,
      })}
    </ToggleButton>
  );
}
